document.addEventListener('DOMContentLoaded', function() {

/* FIX 1: Swiper check — prevents "Swiper is not defined" crash (165 errors/week) */
if (typeof Swiper !== 'undefined') {
  var swiper = new Swiper(".upsell-products-container", {
    slidesPerView: 2.5,
    loop: true,
    spaceBetween: 20,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      1024: { slidesPerView: 2.5 },
      768: { slidesPerView: 2 },
      640: { slidesPerView: 2 },
      320: { slidesPerView: 2 }
    },
    on: {
      slideChangeTransitionStart: function () {
        let progress = ((this.realIndex + 1) / this.slides.length) * 100;
        var progressBar = document.querySelector('.swiper-progress-bar');
        if (progressBar) progressBar.style.width = `${progress}%`;
      }
    }
  });
} /* END FIX 1 */


/* FIX 2: Wrapper null check — prevents "querySelectorAll of null" crash (798 errors/week) */
const wrapper = document.querySelector(".offer-slider-wrapper");
if (wrapper) {
  const slides = wrapper.querySelectorAll(".swiper-wrapper .swiper-slide");

  if (slides.length > 1) {
    wrapper.parentElement.classList.add("has-multiple-slides");
  } else {
    wrapper.parentElement.classList.add("no-multiple-slides");
  }

  if (typeof Swiper !== 'undefined') {
    var swiper = new Swiper(".offer-slider-wrapper", {
      slidesPerView: 1,
      autoplay: {
        delay: 3000
      },
      loop: slides.length > 1,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }
} /* END FIX 2 */



      if (typeof Swiper !== 'undefined') {
        var swiper = new Swiper(".drawer-upsell-products", {
            slidesPerView: 2,
            loop: true,
            spaceBetween: 7,
            breakpoints: {
                1024: { slidesPerView: 2 },
                768: { slidesPerView: 2 },
                640: { slidesPerView: 2 },
                320: { slidesPerView: 2 }
            },
        });
      }

   const copyButtons = document.querySelectorAll(".copy-button");

    copyButtons.forEach(button => {
        button.addEventListener("click", function () {
            const promoCode = button.getAttribute("data-code");

            if (promoCode) {
                navigator.clipboard.writeText(promoCode).then(() => {
                    button.classList.add("show-tooltip");

                    setTimeout(() => {
                        button.classList.remove("show-tooltip");
                    }, 2000);
                }).catch(err => {
                    console.error("Failed to copy: ", err);
                });
            }
        });
    });

        })

  function cartDrawerUpdate_slider(isInitialLoad = false) {
          fetch('/cart.js')
            .then(response => response.json())
            .then(data => {
              if (typeof Swiper !== 'undefined') {
                var swiper = new Swiper(".drawer-upsell-products", {
                    slidesPerView: 2,
                    loop: true,
                    spaceBetween: 7,
                    breakpoints: {
                        1024: { slidesPerView: 2 },
                        768: { slidesPerView: 2 },
                        640: { slidesPerView: 2 },
                        320: { slidesPerView: 2 }
                    },
                 });
              }
            });
        }
      document.addEventListener('DOMContentLoaded', () => {
        cartDrawerUpdate_slider(true);
      });

  document.addEventListener("DOMContentLoaded", function () {
      const megaLinks = document.querySelectorAll(".mega");

      megaLinks.forEach(mega => {
          const menuTypeOne = mega.closest(".menu-link").querySelector(".mega-menu-type-one");

          function addActiveClass() {
              mega.classList.add("active");
          }

          function removeActiveClass() {
              mega.classList.remove("active");
          }

          mega.addEventListener("mouseenter", addActiveClass);
          mega.addEventListener("mouseleave", function () {
              setTimeout(() => {
                  if (!menuTypeOne.matches(":hover") && !mega.matches(":hover")) {
                      removeActiveClass();
                  }
              }, 100);
          });

          if (menuTypeOne) {
              menuTypeOne.addEventListener("mouseenter", addActiveClass);
              menuTypeOne.addEventListener("mouseleave", function () {
                  setTimeout(() => {
                      if (!mega.matches(":hover")) {
                          removeActiveClass();
                      }
                  }, 100);
              });
          }
      });
  });


document.addEventListener('DOMContentLoaded', () => {
    const svgWrapper = document.querySelector('.src-styles-bootstrap-_bootstrap-grid_row .svg-wrapper svg');
    if (svgWrapper) {
        svgWrapper.addEventListener('click', () => {
            const popup = document.querySelector('.src-containers-pdp-components-sharePopup-_styles_share-product-popup');
            if (popup) {
                popup.classList.toggle('active');
            }
        });
    }
});
document.addEventListener('DOMContentLoaded', () => {
    const copyLink = document.querySelector('.copy__link');

    if (copyLink) {
        copyLink.addEventListener('click', (event) => {
            event.preventDefault(); // Link ke default behaviour ko rokna
            const currentLink = window.location.href;

            // Link ko clipboard me copy karna
            navigator.clipboard.writeText(currentLink).then(() => {
                // Success hone par popup show karna
                showPopup("The link of this product has been copied to clipboard!");
            }).catch((err) => {
                console.error('Failed to copy:', err);
            });
        });
    }
});

function showPopup(message) {
    // Popup ka div create karna
    const popup = document.createElement('div');
    popup.textContent = message;
    popup.style.position = 'fixed';
    popup.style.top = '20px';
    popup.style.right = '20px';
    popup.style.backgroundColor = '#333';
    popup.style.color = '#fff';
    popup.style.padding = '10px 20px';
    popup.style.borderRadius = '8px';
    popup.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
    popup.style.zIndex = '9999';
    popup.style.opacity = '0';
    popup.style.transition = 'opacity 0.3s ease';

    // Body me add karna
    document.body.appendChild(popup);

    // Thoda delay ke saath opacity badhakar visible karna
    setTimeout(() => {
        popup.style.opacity = '1';
    }, 10);

    // 3 second ke baad popup ko remove karna
    setTimeout(() => {
        popup.style.opacity = '0';
        setTimeout(() => {
            popup.remove();
        }, 300);
    }, 3000);
}



document.addEventListener("DOMContentLoaded", () => {
(() => {
    function t(e) {
        return (
            (t =
                "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
                    ? function (t) {
                          return typeof t;
                      }
                    : function (t) {
                          return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                      }),
            t(e)
        );
    }
    function e(t) {
        return (
            (function (t) {
                if (Array.isArray(t)) return n(t);
            })(t) ||
            (function (t) {
                if (("undefined" != typeof Symbol && null != t[Symbol.iterator]) || null != t["@@iterator"]) return Array.from(t);
            })(t) ||
            (function (t, e) {
                if (t) {
                    if ("string" == typeof t) return n(t, e);
                    var r = Object.prototype.toString.call(t).slice(8, -1);
                    return "Object" === r && t.constructor && (r = t.constructor.name), "Map" === r || "Set" === r ? Array.from(t) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? n(t, e) : void 0;
                }
            })(t) ||
            (function () {
                throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            })()
        );
    }
    function n(t, e) {
        (null == e || e > t.length) && (e = t.length);
        for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
        return r;
    }
    function r(e, n) {
        for (var r = 0; r < n.length; r++) {
            var o = n[r];
            (o.enumerable = o.enumerable || !1),
                (o.configurable = !0),
                "value" in o && (o.writable = !0),
                Object.defineProperty(
                    e,
                    (void 0,
                    (i = (function (e, n) {
                        if ("object" !== t(e) || null === e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var o = r.call(e, "string");
                            if ("object" !== t(o)) return o;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return String(e);
                    })(o.key)),
                    "symbol" === t(i) ? i : String(i)),
                    o
                );
        }
        var i;
    }
    function o(t) {
        var e = "function" == typeof Map ? new Map() : void 0;
        return (
            (o = function (t) {
                if (null === t || ((n = t), -1 === Function.toString.call(n).indexOf("[native code]"))) return t;
                var n;
                if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
                if (void 0 !== e) {
                    if (e.has(t)) return e.get(t);
                    e.set(t, r);
                }
                function r() {
                    return i(t, arguments, a(this).constructor);
                }
                return (r.prototype = Object.create(t.prototype, { constructor: { value: r, enumerable: !1, writable: !0, configurable: !0 } })), u(r, t);
            }),
            o(t)
        );
    }
    function i(t, e, n) {
        return (
            (i = c()
                ? Reflect.construct.bind()
                : function (t, e, n) {
                      var r = [null];
                      r.push.apply(r, e);
                      var o = new (Function.bind.apply(t, r))();
                      return n && u(o, n.prototype), o;
                  }),
            i.apply(null, arguments)
        );
    }
    function c() {
        if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
        if (Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
        } catch (t) {
            return !1;
        }
    }
    function u(t, e) {
        return (
            (u = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (t, e) {
                      return (t.__proto__ = e), t;
                  }),
            u(t, e)
        );
    }
    function a(t) {
        return (
            (a = Object.setPrototypeOf
                ? Object.getPrototypeOf.bind()
                : function (t) {
                      return t.__proto__ || Object.getPrototypeOf(t);
                  }),
            a(t)
        );
    }
    void 0 === window.customElements.get("faq-navigation") &&
        window.customElements.define(
            "faq-navigation",
            (function (n) {
                !(function (t, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                    (t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } })), Object.defineProperty(t, "prototype", { writable: !1 }), e && u(t, e);
                })(p, n);
                var o,
                    i,
                    l,
                    f,
                    s =
                        ((l = p),
                        (f = c()),
                        function () {
                            var e,
                                n = a(l);
                            if (f) {
                                var r = a(this).constructor;
                                e = Reflect.construct(n, arguments, r);
                            } else e = n.apply(this, arguments);
                            return (function (e, n) {
                                if (n && ("object" === t(n) || "function" == typeof n)) return n;
                                if (void 0 !== n) throw new TypeError("Derived constructors may only return object or undefined");
                                return (function (t) {
                                    if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                                    return t;
                                })(e);
                            })(this, e);
                        });
                function p() {
                    var t;
                    if (!(this instanceof p)) throw new TypeError("Cannot call a class as a function");

                    // Initialize t
                    t = s.call(this);

                    // Assign t.outerWrapper
                    t.outerWrapper = t.closest("[data-slider-outer-wrapper]");

                    // Null check for outerWrapper
                    if (!t.outerWrapper) {
                        console.error("Element with [data-slider-outer-wrapper] not found.");
                        return;
                    }

                    // Assign other properties
                    t.prev = t.outerWrapper.querySelector("[data-faq-nav-prev]");
                    t.next = t.outerWrapper.querySelector("[data-faq-nav-next]");

                    // Null check for navigation buttons
                    if (!t.prev || !t.next) {
                        return;
                    }

                    // Rest of the code
                    t.slides = t.querySelectorAll(".swiper-slide");
                    t.sections = e(document.querySelectorAll("[data-faq-section]"));
                    t.links = e(t.querySelectorAll(".faq-navigation__navigation-item"));
                    t.activeSection = null;
                    t.linkScrollTarget = !1;
                    t.init();
                    return t;
                }
                return (
                    (o = p),
                    (i = [
                        {
                            key: "init",
                            value: function () {
                                var t = this,
                                    n = (typeof Swiper !== 'undefined') ? new Swiper(this, { slidesPerView: "auto", threshold: 10, draggable: !0, freeMode: !0, spaceBetween: 40, navigation: { nextEl: this.next, prevEl: this.prev }, mousewheel: !0 }) : null;
                                if (!n) return;
                                n.on("touchMove", function () {
                                    n.el.classList.toggle("end-reached", n.isEnd);
                                });
                                var r = new IntersectionObserver(
                                    function (r, o) {
                                        if (
                                            r.find(function (t) {
                                                return t.isIntersecting;
                                            })
                                        ) {
                                            var i = t.sections
                                                    .map(function (t) {
                                                        var e = t.getBoundingClientRect();
                                                        return {
                                                            section: t,
                                                            percentIntersecting: (e.height + (e.top < 0 ? e.top : 0) + (e.bottom > window.innerHeight ? window.innerHeight - e.bottom : 0)) / e.height,
                                                            distanceFromCenter: Math.min(Math.abs(e.top - window.innerHeight / 2), Math.abs(e.bottom - window.innerHeight / 2)),
                                                        };
                                                    })
                                                    .filter(function (t) {
                                                        return t.percentIntersecting > 0;
                                                    }),
                                                c = i.reduce(function (t, e) {
                                                    return t ? (e.distanceFromCenter < t.distanceFromCenter ? e : t) : e;
                                                }, null);
                                            window.scrollY + window.innerHeight > document.body.scrollHeight - 100 && (c = i[i.length - 1]),
                                                window.scrollY < 100 && (c = i[0]),
                                                c &&
                                                    c !== t.activeSection &&
                                                    ((c = t.linkScrollTarget || c.section),
                                                    t.links.forEach(function (t) {
                                                        return t.classList.toggle("active", t === c.matchingLink);
                                                    }),
                                                    t.sections.forEach(function (t) {
                                                        return t.classList.toggle("active", t === c);
                                                    }),
                                                    n.slideTo(
                                                        e(t.links).findIndex(function (t) {
                                                            return t.classList.contains("active");
                                                        })
                                                    ));
                                        }
                                    },
                                    {
                                        threshold: Array.from({ length: 10 }, function (t, e) {
                                            return 0.1 * e;
                                        }),
                                    }
                                );
                                return (
                                    this.sections.forEach(function (t) {
                                        (t.matchingLink = document.querySelector('a[href="#'.concat(t.id, '"]'))), r.observe(t);
                                    }),
                                    this.links.forEach(function (n) {
                                        var r = n.href.split("#")[1],
                                            o = e(t.sections).find(function (t) {
                                                return t.id === r;
                                            });
                                        o &&
                                            n.addEventListener("click", function (e) {
                                                e.preventDefault(),
                                                    (t.linkScrollTarget = o),
                                                    window.scrollTo({ top: o.offsetTop - 240, behavior: "smooth" }),
                                                    setTimeout(function () {
                                                        t.linkScrollTarget = null;
                                                    }, 500);
                                            });
                                    }),
                                    n
                                );
                            },
                        },
                    ]) && r(o.prototype, i),
                    Object.defineProperty(o, "prototype", { writable: !1 }),
                    p
                );
            })(o(HTMLElement))
        );
})();
});

 function calculateProgress(currentVal, targetVal, isInitialLoad = false) {
  let progress_val = targetVal;
  let progressMessage = '';
  const remaining = progress_val - currentVal;

  document.querySelectorAll(".cart-shipping__success").forEach(el => el.style.display = 'none');
  document.querySelectorAll(".progress-message").forEach(el => el.style.display = 'none');

  if (currentVal < progress_val) {
    progressMessage = `Add products worth ₹${remaining} more to get FREE SHIPPING`;
    document.querySelectorAll(".progress-message").forEach(el => {
      el.innerHTML = progressMessage;
      el.style.display = 'block';
    });
  } else {
    progressMessage = 'Congratulations, your shipping is now on us! 🎉';
    document.querySelectorAll(".cart-shipping__success").forEach(el => {
      el.innerHTML = progressMessage;
      el.style.display = 'block';
    });
  }

  const result = Math.min(100, Math.round((100 * currentVal) / progress_val));

  document.querySelectorAll('.cart-shippingThreshold__progress').forEach(el => {
    if (isInitialLoad) {
      el.style.transition = 'none';
      el.style.width = result + '%';
      el.offsetHeight;
      el.style.transition = 'all 1000ms linear';
    } else {
      el.style.width = result + '%';
    }
  });
}

function cartDrawerUpdate() {
        fetch('/cart.js')
          .then(response => response.json())
          .then(data => {
            calculateProgress(data.total_price / 100, 400);
          });
      }

 cartDrawerUpdate();

  // document.addEventListener('DOMContentLoaded', function () {
  //     const giftCheckbox = document.querySelector('#gift-checkbox');
  //     giftCheckbox.addEventListener('change', function () {
  //         if (giftCheckbox.checked) {
  //             let formDataGift = {
  //                 'items': [{
  //                     'id': 45551597388022,
  //                     'quantity': 1
  //                 }],
  //                 sections: 'cart-drawer,cart-icon-bubble'
  //             };

  //             fetch(window.Shopify.routes.root + 'cart/add.js', {
  //                 method: 'POST',
  //                 headers: { 'Content-Type': 'application/json' },
  //                 body: JSON.stringify(formDataGift)
  //             })
  //             .then((response) => response.json())
  //             .then((data) => {
  //                 const DrawerUpdate = new DOMParser().parseFromString(
  //                     data.sections['cart-drawer'],
  //                     'text/html'
  //                 ).querySelector('cart-drawer');

  //                 const BubbleUpdate = new DOMParser().parseFromString(
  //                     data.sections['cart-icon-bubble'],
  //                     'text/html'
  //                 ).querySelector('.shopify-section');

  //                 document.querySelector('cart-drawer').innerHTML = DrawerUpdate.innerHTML;
  //                 document.querySelector('.header__icon--cart').innerHTML = BubbleUpdate.innerHTML;
  //             });

  //         }
  //     });
  // });